import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { Layout } from "../Layout";
import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { useState } from "react";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";
import { AppButton } from "JS/React/Components/AppButton";
import { useFeedback } from "JS/React/Hooks/Feedback";
import { AppEmptyAlertDialog } from "JS/React/Components/AppEmptyAlertDialog";
import { AppBackdropProgress } from "JS/React/Components/Progress/AppBackdropProgress";
import { AppOutlineTextFeild } from "JS/React/Components/TextFields/AppOutlineTextFeild";

const FeedbackList = styled(Layout)({
    flexGrow: 1,
});

const StyledButton = styled(AppButton)({
    height: "30px",
    width: "100px",
    margin: "auto",
});

export const Feedback = () => {
    const { homeStack } = useGlobalNavStack();
    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const [field, setField] = useState("");
    const { feed, loading: feedbackLoader } = useFeedback();
    const [isEmpty, setIsEmpty] = useState(false);

    const handleToggleConfirmDialog = () => {
        setIsEmpty(false);
    };

    const handleFeedback = () => {
        if (field === "") {
            setIsEmpty(true);
        } else {
            setIsEmpty(false);
            feed(field);
        }
    };
    return (
        <FeedbackList>
            <Box display={"flex"} flexDirection={"column"} height={"100%"}>
                <AppHeader
                    title={"Feedback"}
                    canGoBack
                    searchable={false}
                    onBackClick={() => {
                        if (!homeStack?.isHomeTrack) {
                            navigate(linkProvider.react.more().index());
                        } else {
                            navigate(linkProvider.react.home());
                        }
                    }}
                />
                <AppOutlineTextFeild
                    multiline={true}
                    rows={10}
                    variant="outlined"
                    autoFocus={true}
                    placeholder="Please provide your feedback here."
                    style={{
                        paddingBottom: "20px",
                    }}
                    onChange={(e) => setField(e.target.value)}
                ></AppOutlineTextFeild>

                <StyledButton
                    onClick={handleFeedback}
                    disabled={feedbackLoader}
                    buttonVariant="primary-filled"
                >
                    Send
                </StyledButton>
                {feedbackLoader && (
                    <AppBackdropProgress
                        open={feedbackLoader}
                        backdropText={"Sending feedback."}
                    />
                )}

                {isEmpty && (
                    <AppEmptyAlertDialog
                        open={isEmpty}
                        onClose={handleToggleConfirmDialog}
                        popupMainText="Feedback is required."
                        cancelButtonText="OK"
                        showConfirmFirst={false}
                    />
                )}
            </Box>
        </FeedbackList>
    );
};
